<p-dialog header="View public events" [(visible)]="cmpVisible"
          [closable]="true" (onHide)="hide()"
          [modal]="true" [style]="dialogStyle" [minY]="70"
          [maximizable]="true" [baseZIndex]="8000">
  <app-adminlog-public></app-adminlog-public>
</p-dialog>
